<template>
  <Modal
    id="ag-modernello-modal"
    hide-footer
    no-padding
    theme="dark"
    @confirm="$modal.close"
  >
    <div class="relative min-h-[5rem] p-6 pb-0 md:p-8 md:pb-0">
      <Image
        :media="item.featured_image"
        conversion="cover"
        lazy
        responsive
        class="ag-modernello-modal__featured-image"
      />
      <div class="ag-modernello-modal__overlay" />
      <div
        v-if="showEmbed"
        class="ag-modernello-modal__embed"
        :class="`ag-modernello-modal__embed--${item.embed?.type}`"
        v-html="embedCode"
      />
    </div>
    <div class="ag-modernello-modal__body">
      <Heading
        type="h3"
        class="text-lg font-medium leading-6 text-white"
      >
        {{ item.title }}
      </Heading>
      <Markdown
        as="div"
        class="ag-modernello-modal__synopsis"
        :text="item.synopsis"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { DialogTitle } from '@headlessui/vue'

const props = defineProps<{
  item?: ContentBlock
}>()

const showEmbed = computed(() => props.item?.embed?.code)

const embedCode = computed(() => {
  const embedType = props.item?.embed?.type

  if (embedType && ['vimeo', 'youtube'].includes(embedType)) {
    return props.item?.embed?.code.replace(/src=\"(.+?)\"/, 'src="$1&autoplay=1"')
  }

  return props.item?.embed?.code
})
</script>

<style>
.ag-modernello-modal {
  &__featured-image {
    @apply absolute inset-0 h-full w-full rounded-t-lg object-cover opacity-90;
  }

  &__overlay {
    @apply absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent;
  }

  &__embed {
    @apply relative;

    iframe {
      @apply aspect-video w-full rounded-lg focus-visible:outline-none;
    }
  }

  &__body {
    @apply relative p-6 md:p-8;
  }

  &__synopsis {
    @apply mt-3 text-white/80;
  }
}
</style>
